import { getItemFromCollection } from "directus/src/operations";
import { apiRoot } from "services/src/config";

export async function fetchRepo({ id }) {
  // Row ids in the global list are git_repositories ids now.
  return getItemFromCollection("git_repositories", id, {
    fields: ["id", "repository_url", "suffix"],
  });
}

// Summary for the stat cards (one request, up to 100 branches).
export async function fetchBranchSummary({ repository_url }) {
  const { data } = await apiRoot.get("github/repository/branches", {
    params: { repository_url, page: 1, limit: 100 },
  });
  return { items: data?.data || [], total: data?.totalRecords ?? 0 };
}

// Moves the branch HEAD from current_head to expected_head. Backend rejects a stale current_head.
export async function resetBranch({ repository_url, branch, current_head, expected_head }) {
  const { data } = await apiRoot.patch("github/repository/reset_branch", {
    repository_url,
    branch,
    current_head,
    expected_head,
  });
  return data;
}
